module.exports = __webpack_public_path__ + "img/university_8.a50bd39d.png";